var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 164,
    viewBox: "0 0 1280 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-2 161.556C84.6667 167.056 287.4 161.556 405 95.5562C552 13.0562 620.5 -45.9438 860 50.0562C1099.5 146.056 1123.5 134.056 1281 85.0562",
    stroke: "#247EE4",
    strokeDasharray: "20 20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSep);
export default __webpack_public_path__ + "static/media/sep.dace81bb27be56d71a0398c36f4241a5.svg";
export { ForwardRef as ReactComponent };